
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./pages/home/index";
import Shop from "./pages/shop/index";
import Bag from "./pages/bag/index";
import Account from "./pages/account/index";
import User from "./pages/user/index";
import Notice from "./pages/notice/index";

import "./style/global.scss";
import CommonProvider from "./hooks/Common/CommonProvider";
import GlobalProvider from "./hooks/GlobalProvider";
import WalletProvider from "./hooks/Wallet/WalletProvider";
import LayoutProvider from "./hooks/Layout/LayoutProvider";
import Help from "./pages/help";
import HelpEN from './pages/help/index_en'
import Center from "./pages/user/center";
import Level from "./pages/user/level";
import Invite from "./pages/user/invite";
import RB from "./pages/account/RB";
import Shoes from "./pages/shoes";

// import VConsole from 'vconsole';
import Intl from "./lang/intl";

import './utils/flexable'
import Wallet from "./pages/wallet";

// const vConsole = new VConsole();

function App() {

  return (
    <div className="App">
      <CommonProvider>
        <Intl>
          <WalletProvider>
            <GlobalProvider>
              <BrowserRouter>
                <LayoutProvider>
                  <Routes>
                    <Route path="" element={<Home />}></Route>
                   
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/bag" element={<Bag />} />
                    <Route path="/notice" element={<Notice />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/user" element={<User />} />
                    <Route path="/user/center" element={<Center />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/help/en" element={<HelpEN />} />
                    <Route path="/level" element={<Level />} />
                    <Route path="/invite" element={<Invite />} />
                    <Route path="/rb" element={<RB />} />
                    <Route path="/wallet" element={<Wallet />}></Route>
                    <Route path="/shoes/" element={<Shoes />} ></Route>
                  </Routes>
                </LayoutProvider>
              </BrowserRouter>
            </GlobalProvider>
          </WalletProvider>
        </Intl>
      </CommonProvider>
    </div>
  );
}

export default App;

